import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductKeyFeatureComponent } from './product-key-feature.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ProductKeyFeatureComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TabKeyFeatures: {
          component: ProductKeyFeatureComponent,
        },
      },
    }),
  ],
})
export class ProductKeyFeatureModule {}
